import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    FormsModule,
    ReactiveFormsModule,
} from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UiSelectCardComponent } from '@components/shared/ui-select-card-group/ui-select-card/ui-select-card.component';
import { UiAutofocusModule } from '@uipath/angular/directives/ui-autofocus';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';

import { UiSelectCardGroupComponent } from './ui-select-card-group.component';

@NgModule({
    imports: [
        CommonModule,
        MatInputModule,
        MatIconModule,
        MatTooltipModule,
        MatRippleModule,
        ReactiveFormsModule,
        FormsModule,
        UiNgLetModule,
        UiAutofocusModule,
        MatCardModule,
    ],
    declarations: [
        UiSelectCardGroupComponent,
        UiSelectCardComponent,
    ],
    exports: [
        UiSelectCardGroupComponent,
        UiSelectCardComponent,
    ],
})
export class UiSelectCardGroupModule { }
